/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ table: NonNullable<unknown>, seat: NonNullable<unknown> }} Rounds_Find_LocationInputs */



/**
* | output |
* | --- |
* | "{table}, seat {seat}" |
*
* @param {Rounds_Find_LocationInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_find_location = /** @type {((inputs: Rounds_Find_LocationInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Find_LocationInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.table}, siège ${i?.seat}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.table}, asiento ${i?.seat}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.table}, assento ${i?.seat}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.table}, posto ${i?.seat}`)
	return /** @type {LocalizedString} */ (`${i?.table}, seat ${i?.seat}`)
});